import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Section from "./components/Section";

const About = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Aspiricity - About Us</title>
      </Helmet>

      <Header>
        <h1>About Us</h1>
      </Header>

      <Section bgColor="bg-light" textColor="text-dark">

        {/* <MediaPlayer url="https://www.youtube.com/watch?v=IO3lZrm2Y10" /> */}

        <p className="lead">
          Aspiricity was founded on a simple idea: help people grow, build meaningful technology skills, and create positive outcomes through software.
        </p>

        <p>
          Over time, that vision evolved into a broader commitment to software quality, practical consulting, continuous learning, and helping organizations navigate modern technology challenges with confidence.
        </p>

        <h3>What is Aspiricity?</h3>

        <p>
          Aspiricity is a consulting and training platform focused on software quality, modernization, testing, automation, and evolving development practices. We combine technical expertise with a strong belief in mentorship, collaboration, and continuous improvement.
        </p>

        <p>
          As a socially conscious business, we believe technology can create opportunities for both organizations and individuals through education, practical experience, and sustainable professional growth.
        </p>

        <h3>Work with Us</h3>

        <p>
          Whether you are looking to strengthen software delivery processes, improve testing and automation practices, modernize existing systems, or continue growing your own technical skills, Aspiricity is ready to help.
        </p>

        <p>
          Based in Calgary, Canada and operating remotely, we collaborate with clients and learners across a variety of modern software development environments.
        </p>

        <Button as={Link} variant="primary" to="/contact">
          Contact Us
        </Button>

        <br />
      </Section>

      <Footer />
    </React.Fragment>
  );
};

export default About;